import { render, staticRenderFns } from "./visit-card.vue?vue&type=template&id=0ab12d0a&scoped=true&"
import script from "./visit-card.vue?vue&type=script&lang=js&"
export * from "./visit-card.vue?vue&type=script&lang=js&"
import style0 from "./visit-card.vue?vue&type=style&index=0&id=0ab12d0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab12d0a",
  null
  
)

export default component.exports